(() => {
  if (window.WaldexReleasitCommunesLoaded) return;
  window.WaldexReleasitCommunesLoaded = true;

  const communesByRegion = {
    AP: ['ARICA', 'CAMARONES', 'GENERAL LAGOS', 'PUTRE'],
    TA: ['ALTO HOSPICIO', 'CAMIÑA', 'COLCHANE', 'HUARA', 'IQUIQUE', 'PICA', 'POZO ALMONTE'],
    AN: ['ANTOFAGASTA', 'CALAMA', 'MARÍA ELENA', 'MEJILLONES', 'OLLAGÜE', 'SAN PEDRO ATACAMA', 'SIERRA GORDA', 'TALTAL', 'TOCOPILLA'],
    AT: ['ALTO DEL CARMEN', 'CALDERA', 'CHAÑARAL', 'COPIAPÓ', 'DIEGO DE ALMAGRO', 'FREIRINA', 'HUASCO', 'TIERRA AMARILLA', 'VALLENAR'],
    CO: ['ANDACOLLO', 'CANELA', 'COMBARBALÁ', 'COQUIMBO', 'ILLAPEL', 'LA HIGUERA', 'LA SERENA', 'LOS VILOS', 'MONTE PATRIA', 'OVALLE', 'PAIHUANO', 'PUNITAQUI', 'RIO HURTADO', 'SALAMANCA', 'VICUÑA'],
    VS: ['ALGARROBO', 'CABILDO', 'CALERA', 'CALLE LARGA', 'CARTAGENA', 'CASABLANCA', 'CATEMU', 'CONCÓN', 'EL QUISCO', 'EL TABO', 'HIJUELAS', 'ISLA DE PASCUA', 'JUAN FERNÁNDEZ', 'LA CRUZ', 'LA LIGUA', 'LIMACHE', 'LLAILLAY', 'LOS ANDES', 'NOGALES', 'OLMUÉ', 'PANQUEHUE', 'PAPUDO', 'PETORCA', 'PUCHUNCAVÍ', 'PUTAENDO', 'QUILLOTA', 'QUILPUÉ', 'QUINTERO', 'RINCONADA', 'SAN ANTONIO', 'SAN ESTEBAN', 'SAN FELIPE', 'SANTA MARÍA', 'SANTO DOMINGO', 'VALPARAÍSO', 'VILLA ALEMANA', 'VIÑA DEL MAR', 'ZAPALLAR'],
    RM: ['ALHUÉ', 'BUIN', 'CALERA DE TANGO', 'CERRILLOS', 'CERRO NAVIA', 'COLINA', 'CONCHALÍ', 'CURACAVÍ', 'EL BOSQUE', 'EL MONTE', 'ESTACIÓN CENTRAL', 'HUECHURABA', 'INDEPENDENCIA', 'ISLA DE MAIPO', 'LA CISTERNA', 'LA FLORIDA', 'LA GRANJA', 'LA PINTANA', 'LA REINA', 'LAMPA', 'LAS CONDES', 'LO BARNECHEA', 'LO ESPEJO', 'LO PRADO', 'MACUL', 'MAIPÚ', 'MARÍA PINTO', 'MELIPILLA', 'ÑUÑOA', 'PADRE HURTADO', 'PAINE', 'PEDRO AGUIRRE CERDA', 'PEÑAFLOR', 'PEÑALOLÉN', 'PIRQUE', 'PROVIDENCIA', 'PUDAHUEL', 'PUENTE ALTO', 'QUILICURA', 'QUINTA NORMAL', 'RECOLETA', 'RENCA', 'SAN BERNARDO', 'SAN JOAQUÍN', 'SAN JOSÉ MAIPO', 'SAN MIGUEL', 'SAN PEDRO', 'SAN RAMÓN', 'SANTIAGO', 'TALAGANTE', 'TILTIL', 'VITACURA'],
    LI: ['CHÉPICA', 'CHIMBARONGO', 'CODEGUA', 'COINCO', 'COLTAUCO', 'DOÑIHUE', 'GRANEROS', 'LA ESTRELLA', 'LAS CABRAS', 'LITUECHE', 'LOLOL', 'MACHALÍ', 'MALLOA', 'MARCHIHUE', 'MOSTAZAL', 'NANCAGUA', 'NAVIDAD', 'OLIVAR', 'PALMILLA', 'PAREDONES', 'PERALILLO', 'PEUMO', 'PICHIDEGUA', 'PICHILEMU', 'PLACILLA', 'PUMANQUE', 'QUINTA DE TILCOCO', 'RANCAGUA', 'RENGO', 'REQUÍNOA', 'SAN FERNANDO', 'SAN VICENTE', 'SANTA CRUZ'],
    ML: ['CAUQUENES', 'CHANCO', 'COLBÚN', 'CONSTITUCIÓN', 'CUREPTO', 'CURICÓ', 'EMPEDRADO', 'HUALAÑÉ', 'LICANTÉN', 'LINARES', 'LONGAVÍ', 'MAULE', 'MOLINA', 'PARRAL', 'PELARCO', 'PELLUHUE', 'PENCAHUE', 'RAUCO', 'RETIRO', 'RÍO CLARO', 'ROMERAL', 'SAGRADA FAMILIA', 'SAN CLEMENTE', 'SAN JAVIER', 'SAN RAFAEL', 'TALCA', 'TENO', 'VICHUQUÉN', 'VILLA ALEGRE', 'YERBAS BUENAS'],
    NB: ['BULNES', 'CHILLÁN', 'CHILLÁN VIEJO', 'COBQUECURA', 'COELEMU', 'COIHUECO', 'EL CARMEN', 'NINHUE', 'ÑIQUÉN', 'PEMUCO', 'PINTO', 'PORTEZUELO', 'QUILLÓN', 'QUIRIHUE', 'RANQUIL', 'SAN CARLOS', 'SAN FABIÁN', 'SAN IGNACIO', 'SAN NICOLÁS', 'TREGUACO', 'YUNGAY'],
    BI: ['ALTO BIOBÍO', 'ANTUCO', 'ARAUCO', 'CABRERO', 'CAÑETE', 'CHIGUAYANTE', 'CONCEPCIÓN', 'CONTULMO', 'CORONEL', 'CURANILAHUE', 'FLORIDA', 'HUALPÉN', 'HUALQUI', 'LAJA', 'LEBU', 'LOS ÁLAMOS', 'LOS ÁNGELES', 'LOTA', 'MULCHÉN', 'NACIMIENTO', 'NEGRETE', 'PENCO', 'QUILACO', 'QUILLECO', 'SAN PEDRO DE LA PAZ', 'SAN ROSENDO', 'SANTA BÁRBARA', 'SANTA JUANA', 'TALCAHUANO', 'TIRÚA', 'TOMÉ', 'TUCAPEL', 'YUMBEL'],
    AR: ['ANGOL', 'CARAHUE', 'CHOLCHOL', 'COLLIPULLI', 'CUNCO', 'CURACAUTÍN', 'CURARREHUE', 'ERCILLA', 'FREIRE', 'GALVARINO', 'GORBEA', 'LAUTARO', 'LONCOCHE', 'LONQUIMAY', 'LOS SAUCES', 'LUMACO', 'MELIPEUCO', 'NUEVA IMPERIAL', 'PADRE LAS CASAS', 'PERQUENCO', 'PITRUFQUÉN', 'PUCÓN', 'PURÉN', 'RENAICO', 'SAAVEDRA', 'TEMUCO', 'TEODORO SCHMIDT', 'TOLTÉN', 'TRAIGUÉN', 'VICTORIA', 'VILCÚN', 'VILLARRICA'],
    LR: ['CORRAL', 'FUTRONO', 'LA UNIÓN', 'LAGO RANCO', 'LANCO', 'LOS LAGOS', 'MÁFIL', 'MARIQUINA', 'PAILLACO', 'PANGUIPULLI', 'RÍO BUENO', 'VALDIVIA'],
    LL: ['ANCUD', 'CALBUCO', 'CASTRO', 'CHAITÉN', 'CHONCHI', 'COCHAMÓ', 'CURACO DE VÉLEZ', 'DALCAHUE', 'FRESIA', 'FRUTILLAR', 'FUTALEUFÚ', 'HUALAIHUÉ', 'LLANQUIHUE', 'LOS MUERMOS', 'MAULLÍN', 'OSORNO', 'PALENA', 'PUERTO MONTT', 'PUERTO OCTAY', 'PUERTO VARAS', 'PUQUELDÓN', 'PURRANQUE', 'PUYEHUE', 'QUEILÉN', 'QUELLÓN', 'QUEMCHI', 'QUINCHAO', 'RÍO NEGRO', 'SAN JUAN DE LA COSTA', 'SAN PABLO'],
    AI: ['AISÉN', 'CHILE CHICO', 'CISNES', 'COCHRANE', 'COIHAIQUE', 'GUAITECAS', 'LAGO VERDE', "O'HIGGINS", 'RÍO IBÁÑEZ', 'TORTEL'],
    MA: ['ANTÁRTICA', 'CABO DE HORNOS', 'LAGUNA BLANCA', 'NATALES', 'PORVENIR', 'PRIMAVERA', 'PUNTA ARENAS', 'RÍO VERDE', 'SAN GREGORIO', 'TIMAUKEL', 'TORRES DEL PAINE']
  };

  const inputValueSetter = Object.getOwnPropertyDescriptor(HTMLInputElement.prototype, 'value').set;
  const selectValueSetter = Object.getOwnPropertyDescriptor(HTMLSelectElement.prototype, 'value').set;
  const SANTIAGO_REGION_CODE = 'RM';
  const SANTIAGO_REGION_NAME = 'Región Metropolitana de Santiago';

  const formatName = (name) => {
    const smallWords = new Set(['de', 'del', 'la', 'las', 'los', 'y']);
    return name
      .toLocaleLowerCase('es-CL')
      .split(' ')
      .map((word, index) => {
        if (index > 0 && smallWords.has(word)) return word;
        return word.replace(/(^|[-'])\p{L}/gu, (letter) => letter.toLocaleUpperCase('es-CL'));
      })
      .join(' ');
  };

  const setReleasitCity = (input, value) => {
    inputValueSetter.call(input, value);
    input.dispatchEvent(new Event('input', { bubbles: true }));
    input.dispatchEvent(new Event('change', { bubbles: true }));
  };

  const lockRegionToSantiago = (region) => {
    if (region.dataset.waldexSantiagoLocked !== 'true') {
      region.replaceChildren();
      const option = document.createElement('option');
      option.value = SANTIAGO_REGION_CODE;
      option.textContent = SANTIAGO_REGION_NAME;
      option.selected = true;
      region.append(option);
      region.dataset.waldexSantiagoLocked = 'true';
      region.setAttribute('aria-label', SANTIAGO_REGION_NAME);
      region.setAttribute('aria-disabled', 'true');
      region.tabIndex = -1;
      region.style.pointerEvents = 'none';
      region.style.cursor = 'not-allowed';
      region.style.backgroundColor = '#f1f5f9';
    }

    selectValueSetter.call(region, SANTIAGO_REGION_CODE);
    region.value = SANTIAGO_REGION_CODE;
  };

  const populateCommunes = (region, input, select) => {
    lockRegionToSantiago(region);
    const regionCode = SANTIAGO_REGION_CODE;
    const communes = communesByRegion[regionCode] || [];
    const previousValue = input.value;

    select.replaceChildren();
    const placeholder = document.createElement('option');
    placeholder.value = '';
    placeholder.textContent = communes.length ? 'Selecciona una comuna' : 'Selecciona primero una región';
    placeholder.disabled = true;
    placeholder.selected = !communes.includes(previousValue.toLocaleUpperCase('es-CL'));
    select.append(placeholder);

    communes.forEach((commune) => {
      const option = document.createElement('option');
      option.value = formatName(commune);
      option.textContent = formatName(commune);
      option.selected = option.value === previousValue;
      select.append(option);
    });

    select.disabled = communes.length === 0;
    if (!communes.some((commune) => formatName(commune) === previousValue)) {
      setReleasitCity(input, '');
    }
  };

  const mountCommuneSelect = (form) => {
    const region = form.querySelector('#province_country_field');
    const input = form.querySelector('#city');
    if (!region || !input) return;
    lockRegionToSantiago(region);

    const row = input.closest('.rsi-text-input-row');
    const wrapper = input.closest('.rsi-text-input-wrapper');
    if (!row || !wrapper) return;

    let select = row.querySelector('.rsi-commune-select-field');
    if (!select) {
      select = document.createElement('select');
      select.id = 'waldex_commune';
      select.className = 'rsi-select-field rsi-commune-select-field';
      select.setAttribute('aria-label', 'Comuna');
      select.required = true;
      input.classList.add('rsi-city-source-field');
      input.setAttribute('aria-hidden', 'true');
      input.tabIndex = -1;
      row.append(select);

      const label = wrapper.querySelector('label');
      if (label) label.htmlFor = select.id;
    }

    select.dataset.sourceInput = input.id;
    const syncKey = `${region.value}|${input.value}`;
    if (select.dataset.syncKey === syncKey) return;
    select.dataset.syncKey = syncKey;
    populateCommunes(region, input, select);
  };

  document.addEventListener('change', (event) => {
    const form = event.target.closest('#rsi_form_wrapper');
    if (!form) return;

    if (event.target.matches('#province_country_field')) {
      lockRegionToSantiago(event.target);
      mountCommuneSelect(form);
      return;
    }

    if (event.target.matches('.rsi-commune-select-field')) {
      const input = form.querySelector('#city');
      if (input) setReleasitCity(input, event.target.value);
    }
  });

  const isSantiagoCommune = (value) => communesByRegion.RM
    .some((commune) => formatName(commune) === value);

  const validateSantiagoDelivery = (form) => {
    const region = form.querySelector('#province_country_field');
    const city = form.querySelector('#city');
    const commune = form.querySelector('.rsi-commune-select-field');
    if (!region || !city || !commune) return false;

    lockRegionToSantiago(region);
    const valid = isSantiagoCommune(commune.value) && commune.value === city.value;
    commune.setCustomValidity(valid ? '' : 'Selecciona una comuna de la Región Metropolitana de Santiago.');
    if (!valid) {
      commune.reportValidity();
      commune.focus();
    }
    return valid;
  };

  document.addEventListener('submit', (event) => {
    const wrapper = event.target.closest('#rsi_form_wrapper');
    if (!wrapper || validateSantiagoDelivery(wrapper)) return;
    event.preventDefault();
    event.stopImmediatePropagation();
  }, true);

  document.addEventListener('click', (event) => {
    const button = event.target.closest('#rsi_form_wrapper .rsi-custom-button');
    if (!button) return;
    const wrapper = button.closest('#rsi_form_wrapper');
    if (validateSantiagoDelivery(wrapper)) return;
    event.preventDefault();
    event.stopImmediatePropagation();
  }, true);

  const mountOpenForms = () => {
    document.querySelectorAll('#rsi_form_wrapper').forEach(mountCommuneSelect);
  };

  new MutationObserver(mountOpenForms).observe(document.documentElement, {
    childList: true,
    subtree: true
  });

  mountOpenForms();
})();
